import { h } from 'preact';
import { SelectEntry } from '@epx/flow';

const GATEWAY_TYPES = [
  'epx:ExclusiveGateway',
  'epx:ParallelGateway',
  'epx:InclusiveGateway',
  'epx:ComplexGateway',
  'epx:EventBasedGateway',
];

// "Optiondefault" is the sfd default value stored in XML — must be in options
const getExtraSplitTypes = (i18n) => [
  { value: '', label: i18n['opt.default'] || '-- Default --' },
  { value: 'Optiondefault', label: i18n['opt.Optiondefault'] || 'Default (Conditional)' },
  { value: 'ApprovalOrSplit', label: i18n['opt.ApprovalOrSplit'] || 'Approval Or Split' },
  { value: 'AndSplitMI', label: i18n['opt.AndSplitMI'] || 'AND Split MI' },
];

const getExtraJoinTypes = (i18n) => [
  { value: '', label: i18n['opt.default'] || '-- Default --' },
  { value: 'EOrJoin', label: i18n['opt.EOrJoin'] || 'Enhanced OR Join' },
  { value: 'AndJoinMI', label: i18n['opt.AndJoinMI'] || 'AND Join MI' },
];

export class SfdGatewayExtension {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return GATEWAY_TYPES.includes(elementType);
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'sfdGateway',
        label: i18n.sfdGateway || 'SFD Gateway Options',
        isEdited: () => !!(props.extraSplitType || props.extraJoinType),
        entries: [
          {
            id: 'extraSplitType',
            component: () => (
              <SelectEntry
                id="sfd-extraSplitType"
                label={i18n.extraSplitType || 'Extra Split Type'}
                value={props.extraSplitType || ''}
                options={getExtraSplitTypes(i18n)}
                onChange={(val) => update('extraSplitType', val)}
              />
            ),
          },
          {
            id: 'extraJoinType',
            component: () => (
              <SelectEntry
                id="sfd-extraJoinType"
                label={i18n.extraJoinType || 'Extra Join Type'}
                value={props.extraJoinType || ''}
                options={getExtraJoinTypes(i18n)}
                onChange={(val) => update('extraJoinType', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
